/** @format */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useEffect, useState } from "react";

export const MyDnvDevAppSubscriptions = ({ optionsList, onSave, onCancel }) => {
    const [localOptionsList, setLocalOptionsList] = useState([]);
    const [selectAllToggled, setSelectAllToggled] = useState(false);

    useEffect(() => {
        setLocalOptionsList([...optionsList]);
        setSelectAllToggled(optionsList.every((entry) => entry.Selected));
    }, [optionsList]);

    const handleOptionSelected = (option) => {
        let indexOption = localOptionsList.findIndex((entry) => entry.name === option.name);
        let newOptionsList = [
            ...localOptionsList.slice(0, indexOption),
            { ...option, Selected: !option.Selected },
            ...localOptionsList.slice(indexOption + 1, localOptionsList.length),
        ];

        setLocalOptionsList(newOptionsList);
        setSelectAllToggled(newOptionsList.every((entry) => entry.Selected));
    };

    const handleSelectAllSelected = () => {
        let selectState = !selectAllToggled;
        setSelectAllToggled(selectState);
        setLocalOptionsList(
            localOptionsList.map((option) => ({
                ...option,
                Selected: selectState,
            }))
        );
    };

    const handleSaveSelections = () => onSave(localOptionsList);
    const handleCancelSelections = () => onCancel();

    return (
        <>
            <div className='myDnvDevAppSubscriptions'>
                <div className='optionsList'>
                    <div className='optionEntry'>
                        <label>
                            <input
                                type='checkbox'
                                id='select-all-checkbox'
                                name='selectAll'
                                checked={selectAllToggled}
                                onChange={handleSelectAllSelected}
                            />
                            <span>Select all</span>
                        </label>
                    </div>

                    {localOptionsList.map((option, index) => (
                        <div className='optionEntry' key={index}>
                            <label>
                                <input
                                    type='checkbox'
                                    id={option.id}
                                    name={option.name}
                                    checked={option.Selected}
                                    onChange={() => handleOptionSelected(option)}
                                />
                                <span>{option.name}</span>
                            </label>
                        </div>
                    ))}
                </div>

                <div className='infoContainer'>
                    <div className='infoIcon'>
                        <span className='iconLayerBlock fa-layers fa-fw fa-lg'>
                            <FontAwesomeIcon icon={"fa-solid fa-message"} />
                            <FontAwesomeIcon icon={"fa-solid fa-info"} />
                        </span>
                    </div>

                    <div className='infoMsg'>
                        You can refer to{" "}
                        <a
                            href='https://www.google.com/maps/d/u/2/embed?mid=1PRqgb9xFFLIg4mk4GzbTTakRhYQ&ll=49.33333767646741%2C-123.03182245000002&z=12'
                            target='_'
                        >
                            this DNV map
                        </a>{" "}
                        to locate and identify areas of interest.
                    </div>
                </div>

                <div className='buttonsContainer'>
                    <div className='saveBtn' onClick={handleSaveSelections}>
                        <span>Save</span>
                    </div>
                    <div className='cancelBtn' onClick={handleCancelSelections}>
                        <span>Cancel</span>
                    </div>
                </div>
            </div>
        </>
    );
};
